export default (format: string) => (format ? (format === 'webm' || format === 'webp' ? `Web${format[3].toUpperCase()}` : format.toUpperCase()) : null);
